import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type MessengerChat as SchemaMessengerChat } from '../schemas/MessengerChat';
import { type MessengerSendRequest as SchemaMessengerSendRequest } from '../schemas/MessengerSendRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Messenger
 */
export const SendMessengerMessageContentType = 'application/json' as const;
export type SendMessengerMessageRequest = SchemaMessengerSendRequest;
export type SendMessengerMessageResponses = LinkCommonErrorResponses & {
    /**
     * @description Messages sent to Messenger
     */
    '200': {
        'application/json': SchemaMessengerChat;
    };
};
export type SendMessengerMessageResponseSuccess = SendMessengerMessageResponses['200']['application/json'];
export type SendMessengerMessageSearchParams = undefined;
export type SendMessengerMessagePathParameters = undefined;
export const SendMessengerMessageUrl = '/messenger/message' as const;
export const SendMessengerMessageMethod = 'POST' as const;
export const getSendMessengerMessageUrl = (_params?: SendMessengerMessagePathParameters) => SendMessengerMessageUrl;
